import React from 'react';
import { RhCheckbox } from '../../../../../../../dum';
import { IS_LEADER } from '../../employee-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function EmployeeIsLeaderInput() {
    return (
        <RhCheckbox
            name={IS_LEADER}
            label={shortLabel(FIELD_LABELS.is_leader)}
            disableGutters
        />
    );
}
